<template>
    <div :class="`col-md-${colSize}`" class="mt-2 text-center">
        <h4 class="board-name">{{ name }}</h4>
        <h6 class="board-name"><u><i>{{ year }}</i></u></h6>
        <h6 class="member-name">Dhr. {{ preases }}</h6>
        <h6 class="member-name">Dhr. {{ abactis }}</h6>
        <h6 class="member-name">Dhr. {{ questor }}</h6>
    </div>
</template>

<script>
    export default {
        name: 'Bestuur',
        props: {
            colSize: {
              required: false,
              default: 2
            },
            name: {
                type: String,
                required: true
            },
            year: {
                type: String,
                required: true
            },
            preases: {
                type: String,
                required: true
            },
            abactis: {
                type: String,
                required: true
            },
            questor: {
                type: String,
                required: true
            }
        }
    }
</script>

<style>
    .board-name {
        /*color: white;*/
        /*text-align: center;*/
        text-decoration-color: gold;
    }

    .member-name {
        /*color: white;*/
        /*text-align: center;*/
    }

    .superRole {
        color: gold;
    }

    .fade-enter-active {
        transition: opacity 3s ease-in-out;
    }

    .fade-enter-to {
        opacity: 1;
    }

    .fade-enter, .fade-leave-to{
        opacity: 0;
    }

    .fade-leave-active {
        transition: opacity 1s ease-out;
    }
</style>
